export default {
  appTitle: process.env.VUE_APP_TITLE,
  appVersion: process.env.VUE_APP_VERSION,
  baseUrl: process.env.VUE_APP_BASE_URL,
  uploadImageUrl: process.env.VUE_APP_UPLOAD_IMAGE_URL,
  viewImageUrl: process.env.VUE_APP_VIEW_IMAGE_URL,
  superUser: "admin",
  userBaseUrl: "/epicph",
  subAccessRoles: {
    account: "account",
    ticket: "ticket",
    bank: "bank",
    promotion: "promotion",
    rescuefund: "rescuefund",
    turnovertier: "turnovertier",
    vip: "vip",
    report: "report",
    log: "log",
    system: "system",
    setup: "setup",
    minigame: "minigame",
    affiliate: "affiliate",
    cms: "cms"
  },
  pageParent: {
    setting: "system",
    account: "account",
    dashboard: "system",
    operator: "account",
    memberlist: "account",
    subaccount: "account",
    socialaccount: "account",
    ipwhitelist: "account",
    membercustomvip: "account",
    ticket: "ticket",
    ticketlist: "ticket",
    ticketlistautowithdrawal: "ticket",
    pendingticket: "ticket",
    bank: "bank",
    bankgroup: "bank",
    paymentoption: "bank",
    bankoperator: "bank",
    bankmember: "bank",
    bankmemberewallet: "bank",
    bankprovider: "bank",
    rescuefund: "rescuefund",
    turnovertier: "turnovertier",
    vip: "vip",
    promotion: "promotion",
    promogroup: "promotion",
    promopackage: "promotion",
    promoaccount: "promotion",
    promomember: "promotion",
    ibankaccount: "bank",
    membernickname: "account",
    coupon: "promotion",
    campaign: "promotion",
    setup: "setup",
    providermaintenance: "setup",
    withdrawallimit: "setup",
    providerbetlimit: "setup",
    providergameoff: "setup",
    providerrtp: "setup",
    globalsetting: "setup",
    refereelist: "report",
    minigame: "minigame",
    matchlist: "minigame",
    teamlist: "minigame",
    matchteamlog: "minigame",
    matchresultlog: "minigame",
    bankstatement: "report",
    bankstatementdaily: "report",
    onetimedepositor: "report",
    currentmonthnondepositor: "report",
    currentmonthnologin: "report",
    promotionsummary: "report",
    adjustmemberlog: "log",
    issuebonuslog: "log",
    dailystatement: "report",
    dailywinlose: "report",
    gameresultchangeslog: "log",
    platformwinlose: "report",
    dailysummarycompany: "report",
    dailysummarymember: "report",
    gameresultslots: "report",
    gameresultlivecasino: "report",
    gameresultrebate: "report",
    gameresultsportsbook: "report",
    gameresultcockfight: "report",
    gameresultrescue: "report",
    bonuslist: "report",
    adjustmentlist: "report",
    ticketwallettranslist: "report",
    promotionsignupunusedlist: "report",
    promotionsignupongoing: "report",
    promosignup: "promotion",
    depositedmember: "report",
    registeredmember: "report",
    firstdeposit: "report",
    crmlist: "report",
    utmlist: "report",
    memberexport: "export_excel",
    ticketexport: "export_excel",
    providerwinlosecompany: "providerwinlose",
    affiliate: "affiliate",
    globalsettingaffiliate: "affiliate",
    approveaffiliate: "affiliate",
    affiliatelist: "affiliate",
    bankaffiliate: "affiliate",
    ticketlistaffiliate: "affiliate",
    pendingticketaffiliate: "affiliate",
    ticketlistreviewauditaffiliate: "affiliate",
    adjustmentlogaffiliate: "affiliate",
    settlementlogaffiliate: "affiliate",
    adjustmentlistaffiliate: "affiliate",
    settlementlistaffiliate: "affiliate",
    dailywithdrawalaffiliate: "affiliate",
    dailystatementaffiliate: "affiliate",
    dailywinloseaffiliate: "affiliate",
    dashboardaffiliate: "affiliate",
    dailydepositaffiliate: "affiliate",
    // settlementlistaffiliate: "affiliate",
    // dailywinlosememberaffiliate: "affiliate",
    // commupdatelogaffiliate: "affiliate",
    // playerlist: "affiliate",
    reviewlist: "account",
    monthlyrating: "account",
    surveylist: "account",
    cms: "cms",
    announcementbanner: "cms",
    promotionbanner: "cms",
    slidebanner: "cms",
    seopage: "cms",
    ticketlogautowithdrawal: "log",
    memberbonus: "account",
    loginmemberlog: "log",
    memberviplog: "log",
    memberdetails: "account",
    rebatesummary: "report",
    rebatesummaryv2: "report",
    rebatelistmember: "report",
    systembalance: "setup",
    ticketlistreviewaudit: "ticket",
    dailywinlosesb: "report",
    dailywinlosesbdetail: "report",
    smarticobonusreport: "report",
    providerwinlosemember: "providerwinlose",
    ticketlistautowithdrawalexport: "export_excel",
    retention: "report",
    cohort: "report",
    promotionwithdrawalsummary: "report",
    uniquelogin: "report",
    uniquewithdrawal: "report",
    seconddeposit: "report",
    bankdefaultsender: "bank",
    memberlabel: "account",
    iframe: "setup",
    exchangerate: "setup",
    smarticobonusreportexpired: "report",
    rescuefundpayout: "report",
    dailywinlosegame: "report",
    gamenameexclude: "setup",
    logrepulling: "setup",
  },
  accessRoles: {
    account: "account",
    dashboard: "dashboard",
    operator: "operator",
    memberlist: "memberlist",
    subaccount: "subaccount",
    ipwhitelist: "ipwhitelist",
    ticket: "ticket",
    ticketlist: "ticketlist",
    ticketlistautowithdrawal: "ticketlistautowithdrawal",
    pendingticket: "pendingticket",
    bank: "bank",
    bankgroup: "bankgroup",
    paymentoption: "paymentoption",
    bankoperator: "bankoperator",
    bankmember: "bankmember",
    bankmemberewallet: "bankmemberewallet",
    bankprovider: "bankprovider",
    security: "security",
    setting: "setting",
    report: "report",
    rescuefund: "rescuefund",
    turnovertier: "turnovertier",
    vip: "vip",
    promotion: "promotion",
    promogroup: "promogroup",
    promopackage: "promopackage",
    promoaccount: "promoaccount",
    promomember: "promomember",
    ibankaccount: "ibankaccount",
    socialaccount: "socialaccount",
    membernickname: "membernickname",
    coupon: "coupon",
    campaign: "campaign",
    setup: "setup",
    providermaintenance: "providermaintenance",
    withdrawallimit: "withdrawallimit",
    providerbetlimit: "providerbetlimit",
    providergameoff: "providergameoff",
    providerrtp: "providerrtp",
    globalsetting: "globalsetting",
    refereelist: "refereelist",
    minigame: "minigame",
    matchlist: "matchlist",
    teamlist: "teamlist",
    matchteamlog: "matchteamlog",
    matchresultlog: "matchresultlog",
    bankstatement: "bankstatement",
    bankstatementdaily: "bankstatementdaily",
    onetimedepositor: "onetimedepositor",
    currentmonthnondepositor: "currentmonthnondepositor",
    currentmonthnologin: "currentmonthnologin",
    promotionsummary: "promotionsummary",
    adjustmemberlog: "adjustmemberlog",
    issuebonuslog: "issuebonuslog",
    dailystatement: "dailystatement",
    dailywinlose: "dailywinlose",
    gameresultchangeslog: "gameresultchangeslog",
    platformwinlose: "platformwinlose",
    dailysummarycompany: "dailysummarycompany",
    dailysummarymember: "dailysummarymember",
    gameresultslots: "gameresultslots",
    gameresultlivecasino: "gameresultlivecasino",
    gameresultrebate: "gameresultrebate",
    gameresultsportsbook: "gameresultsportsbook",
    gameresultcockfight: "gameresultcockfight",
    gameresultrescue: "gameresultrescue",
    bonuslist: "bonuslist",
    adjustmentlist: "adjustmentlist",
    ticketwallettranslist: "ticketwallettranslist",
    promotionsignupunusedlist: "promotionsignupunusedlist",
    promotionsignupongoing: "promotionsignupongoing",
    promosignup: "promosignup",
    depositedmember: "depositedmember",
    registeredmember: "registeredmember",
    firstdeposit: "firstdeposit",
    crmlist: "crmlist",
    utmlist: "utmlist",
    memberexport: "memberexport",
    ticketexport: "ticketexport",
    providerwinlosecompany: "providerwinlosecompany",
    affiliate: "affiliate",
    approveaffiliate: "affiliate",
    affiliatelist: "affiliate",
    bankaffiliate: "affiliate",
    ticketlistaffiliate: "affiliate",
    pendingticketaffiliate: "affiliate",
    ticketlistreviewauditaffiliate: "affiliate",
    adjustmentlogaffiliate: "affiliate",
    settlementlogaffiliate: "affiliate",
    adjustmentlistaffiliate: "affiliate",
    settlementlistaffiliate: "affiliate",
    dailywithdrawalaffiliate: "affiliate",
    dailystatementaffiliate: "affiliate",
    globalsettingaffiliate: "affiliate",
    dailywinloseaffiliate: "affiliate",
    dashboardaffiliate: "affiliate",
    dailydepositaffiliate: "affiliate",
    // settlementlistaffiliate: "settlementlistaffiliate",
    // dailywinlosememberaffiliate: "dailywinlosememberaffiliate",
    // commupdatelogaffiliate: "commupdatelogaffiliate",
    // playerlist: "playerlist",
    review: "review",
    reviewlist: "review",
    monthlyrating: "review",
    surveylist: "review",
    cms: "cms",
    announcementbanner: "cms",
    promotionbanner: "cms",
    slidebanner: "cms",
    seopage: "cms",
    ticketlogautowithdrawal: "ticketlogautowithdrawal",
    memberbonus: "memberbonus",
    loginmemberlog: "loginmemberlog",
    memberviplog: "memberviplog",
    memberdetails: "memberdetails",
    rebatesummary: "rebatesummary",
    rebatesummaryv2: "rebatesummaryv2",
    rebatelistmember: "rebatelistmember",
    systembalance: "systembalance",
    ticketlistreviewaudit: "ticketlistreviewaudit",
    dailywinlosesb: "dailywinlosesb",
    dailywinlosesbdetail: "dailywinlosesbdetail",
    membercustomvip: "membercustomvip",
    smarticobonusreport: "smarticobonusreport",
    providerwinlosemember: "providerwinlosemember",
    ticketlistautowithdrawalexport: "ticketlistautowithdrawalexport",
    retention: "retention",
    cohort: "cohort",
    promotionwithdrawalsummary: "promotionwithdrawalsummary",
    // uniquelogin: "uniquelogin",
    // uniquewithdrawal: "uniquewithdrawal",
    // seconddeposit: "seconddeposit",
    uniquelogin: "dailysummarycompany",
    uniquewithdrawal: "dailysummarycompany",
    seconddeposit: "dailysummarycompany",
    bankdefaultsender: "bankdefaultsender",
    memberlabel: "memberlabel",
    iframe: "iframe",
    exchangerate: "exchangerate",
    smarticobonusreportexpired: "smarticobonusreportexpired",
    rescuefundpayout: "rescuefundpayout",
    dailywinlosegame: "dailywinlosegame",
    gamenameexclude: "gamenameexclude",
    logrepulling: "logrepulling",
  },
  accessUrlPrefix: {
    operator: "/account",
    memberlist: "/account",
    subaccount: "/account",
    ipwhitelist: "/account",
    ticket: "/ticket",
    ticketlist: "/ticket",
    ticketlistautowithdrawal: "/ticket",
    pendingticket: "/ticket",
    bankgroup: "/bank",
    paymentoption: "/bank",
    bankoperator: "/bank",
    bankmember: "/bank",
    bankmemberewallet: "/bank",
    bankprovider: "/bank",
    setting: "/system",
    report: "/report",
    rescuefund: "/rescuefund",
    turnovertier: "/turnovertier",
    vip: "/vip",
    minigame: "/minigame",
    promopackage: "/promotion",
    promogroup: "/promotion",
    promoaccount: "/promotion",
    promomember: "/promotion",
    ibankaccount: "/ibank",
    socialaccount: "/account",
    membernickname: "/account",
    coupon: "/promotion",
    campaign: "/promotion",
    providermaintenance: "/setup",
    withdrawallimit: "/setup",
    providerbetlimit: "/setup",
    providergameoff: "/setup",
    providerrtp: "/setup",
    globalsetting: "/setup",
    refereelist: "/report",
    teamlist: "/minigame",
    matchlist: "/minigame",
    matchteamlog: "/minigame",
    matchresultlog: "/minigame",
    bankstatement: "/report",
    bankstatementdaily: "/report",
    onetimedepositor: "/report",
    currentmonthnondepositor: "/report",
    currentmonthnologin: "/report",
    promotionsummary: "/report",
    adjustmemberlog: "/log",
    issuebonuslog: "/log",
    dailystatement: "/report",
    dailywinlose: "/report",
    gameresultchangeslog: "/log",
    platformwinlose: "/report",
    dailysummarycompany: "/report",
    dailysummarymember: "/report",
    gameresultslots: "/report",
    gameresultlivecasino: "/report",
    gameresultrebate: "/report",
    gameresultsportsbook: "/report",
    gameresultcockfight: "/report",
    gameresultrescue: "/report",
    bonuslist: "/report",
    adjustmentlist: "/report",
    ticketwallettranslist: "/report",
    promotionsignupunusedlist: "/report",
    promotionsignupongoing: "/report",
    promosignup: "/promotion",
    depositedmember: "/report",
    registeredmember: "/report",
    firstdeposit: "/report",
    crmlist: "/report",
    utmlist: "/report",
    providerwinlosecompany: "/report",
    memberexport: "/report",
    ticketexport: "/report",
    approveaffiliate: "/affiliate",
    affiliatelist: "/affiliate",
    bankaffiliate: "/affiliate",
    ticketlistaffiliate: "/affiliate",
    pendingticketaffiliate: "/affiliate",
    ticketlistreviewauditaffiliate: "/affiliate",
    adjustmentlogaffiliate: "/affiliate",
    settlementlogaffiliate: "/affiliate",
    adjustmentlistaffiliate: "/affiliate",
    settlementlistaffiliate: "/affiliate",
    dailywithdrawalaffiliate: "/affiliate",
    dailystatementaffiliate: "/affiliate",
    globalsettingaffiliate: "/affiliate",
    dailywinloseaffiliate: "/affiliate",
    dashboardaffiliate: "/affiliate",
    dailydepositaffiliate: "/affiliate",
    // dailywinlosememberaffiliate: "/affiliate",
    // commupdatelogaffiliate: "/affiliate",
    // playerlist: "/affiliate",
    reviewlist: "/review",
    monthlyrating: "/review",
    surveylist: "/review",
    announcementbanner: "/cms",
    promotionbanner: "/cms",
    slidebanner: "/cms",
    seopage: "/cms",
    ticketlogautowithdrawal: "/log",
    memberbonus: "/account",
    loginmemberlog: "/log",
    memberviplog: "/log",
    memberdetails: "/account",
    rebatesummary: "/report",
    rebatesummaryv2: "/report",
    rebatelistmember: "/report",
    systembalance: "/setup",
    ticketlistreviewaudit: "/ticket",
    dailywinlosesb: "/report",
    dailywinlosesbdetail: "/report",
    membercustomvip: "/account",
    smarticobonusreport: "/report",
    providerwinlosemember: "/report",
    ticketlistautowithdrawalexport: "/report",
    retention: "retention",
    cohort: "/report",
    promotionwithdrawalsummary: "/report",
    uniquelogin: "/report",
    uniquewithdrawal: "/report",
    seconddeposit: "/report",
    bankdefaultsender: "/bank",
    memberlabel: "/account",
    iframe: "/setup",
    exchangerate: "/setup",
    smarticobonusreportexpired: "/report",
    rescuefundpayout: "/report",
    dailywinlosegame: "/report",
    gamenameexclude: "/setup",
    logrepulling: "/setup"
  },
  pgIDPrefix: process.env.VUE_APP_PG_ID_PREFIX,
  affSubAccPasswords: "admin123!@#",
  bankingList: [{ text: 'IBANK', value: 'IBANK'}, { text: 'MANUAL', value: 'MANUAL'}],
  // gameResultDetailUrl: "https://result.apiepiccash.com/result?bet_id=",
  resultDetailProvider: [
    "EPIC", "LIVE22", "SB", "EVO", "T1", "TP", "HACKSAW", "FASTSPIN", "FC", "JDB", "JILI",
    "PG", "SEXYBCRT", "VENUS", "YESBINGO", "YL", "JILI2", "EPIC2", "HBNR", "CQ9", "PP-S",
    "QM", "MG", "SPNX", "SPDG", "BG", "HSG", "RG", "EVOP", "PNG", "EVONTT", "EVORT", "EVOBTG",
    "EVONLC", "BNG", "AP", "ALG", "SPB", "WIFY", "YB", "BG-S", "PP-S1", "PP-S123", "YGR", "HSD",
    "MEGAH5", "TBL", "WOW"
  ],
  resultDetail: {
    "epicUrl": process.env.VUE_APP_BET_DETAIL_URL_EPIC + "/result?bet_id=",
    "awcUrl": process.env.VUE_APP_BET_DETAIL_URL_AWC + "/getbetdetail",
    "live22Url": process.env.VUE_APP_BET_DETAIL_URL_LIVE22 + "/getbetdetail",
    "evoUrl": process.env.VUE_APP_BET_DETAIL_URL_EVO + "/getbetdetail",
    "t1Url": process.env.VUE_APP_BET_DETAIL_URL_T1 + "/getbetdetail",
    "tpUrl": process.env.VUE_APP_BET_DETAIL_URL_TP + "/getbetdetail",
    "hacksawUrl": process.env.VUE_APP_BET_DETAIL_URL_HACKSAW + "/getbetdetail",
    "jili2Url": process.env.VUE_APP_BET_DETAIL_URL_JILI2 + "/getbetdetail",
    "epic2Url": process.env.VUE_APP_BET_DETAIL_URL_EPIC2 + "/getbetdetail",
    "cq9Url": process.env.VUE_APP_BET_DETAIL_URL_CQ9 + "/getbetdetail",
    "habaneroUrl": process.env.VUE_APP_BET_DETAIL_URL_HBNR + "/getbetdetail",
    "fcUrl": process.env.VUE_APP_BET_DETAIL_URL_FC + "/getbetdetail",
    "ppsUrl": process.env.VUE_APP_BET_DETAIL_URL_PPS + "/getbetdetail",
    "oneUrl": process.env.VUE_APP_BET_DETAIL_URL_ONE + "/getbetdetail",
    "pps123Url": process.env.VUE_APP_BET_DETAIL_URL_PPS123 + "/getbetdetail",
    "ygrUrl": process.env.VUE_APP_BET_DETAIL_URL_YGR + "/getbetdetail",
    "megah5Url": process.env.VUE_APP_BET_DETAIL_URL_MEGAH5 + "/getbetdetail",
    "wowUrl": process.env.VUE_APP_BET_DETAIL_URL_WOW + "/getbetdetail",
    "tblUrl": process.env.VUE_APP_BET_DETAIL_URL_TBL + "/result?action_by={0}&auth_token={1}&result_id={2}&provider=TBL",
  },
  getGameList: {
    "epicUrl": process.env.VUE_APP_GAME_LIST_URL_EPIC + "/osg/getGameList?lang=en",
    "awcUrl": process.env.VUE_APP_GAME_LIST_URL_AWC + "/getgamelist",
    "live22Url": process.env.VUE_APP_GAME_LIST_URL_LIVE22 + "/getgamelist?lang=en",
    "t1Url": process.env.VUE_APP_GAME_LIST_URL_T1 + "/getgamelist",
    "jili2Url": process.env.VUE_APP_GAME_LIST_URL_JILI2 + "/opgetgamelist",
    "epic2Url": process.env.VUE_APP_GAME_LIST_URL_EPIC2 + "/getgamelist?lang=en",
    "habaneroUrl": process.env.VUE_APP_GAME_LIST_URL_HBNR + "/getgamelist",
    "cq9Url": process.env.VUE_APP_GAME_LIST_URL_CQ9 + "/getgamelist",
    "fcUrl": process.env.VUE_APP_GAME_LIST_URL_FC + "/getgamelist",
    "ppsUrl": process.env.VUE_APP_GAME_LIST_URL_PPS + "/getgamelist",
    "oneUrl": process.env.VUE_APP_GAME_LIST_URL_ONE + "/getgamelist",
    "pps123Url": process.env.VUE_APP_GAME_LIST_URL_PPS123 + "/getgamelist",
    "ygrUrl": process.env.VUE_APP_GAME_LIST_URL_YGR + "/getgamelist",
    "megah5Url": process.env.VUE_APP_GAME_LIST_URL_MEGAH5 + "/getgamelist?lang=en",
    "wowUrl": process.env.VUE_APP_GAME_LIST_URL_WOW + "/getbetdetail",
  },
  logRepulling: {
    "oneUrl": process.env.VUE_APP_LOG_REPULL_URL_ONE + "/FilteredReport",
  },
  gameIdField: {
    "EPIC": "GameCode",
    "LIVE22": "GameId",
    "JILI": "game_code",
    // "FC": "game_code",
    "PG": "game_code",
    "FASTSPIN": "game_code",
    "YESBINGO": "game_code",
    "JDB": "game_code",
    "JILI2": "game_code",
    "EPIC2": "GameCode",
    "HBNR": "KeyName",
    "CQ9": "gamecode",
    "FC": "Key",
    "PP-S": "gameID",
    "MG": "game_code",
    "SPNX": "game_code",
    "SPDG": "game_code",
    "BG": "game_code",
    "HSG": "game_code",
    "RG": "game_code",
    "EVOP": "game_code",
    "PNG": "game_code",
    "EVONTT": "game_code",
    "EVORT": "game_code",
    "EVOBTG": "game_code",
    "EVONLC": "game_code",
    "BNG": "game_code",
    "AP": "game_code",
    "ALG": "game_code",
    "SPB": "game_code",
    //"CQ9": "game_code",
    "BG-S": "game_code",
    "PP-S123": "gameID",
    "HSD": "game_code",
    "YGR": "GameId",
    "MEGAH5": "GameCode",
  },
  gameNameField: {
    "EPIC": "GameName",
    "LIVE22": "GameName",
    "JILI": "game_name",
    // "FC": "game_name",
    "PG": "game_name",
    "FASTSPIN": "game_name",
    "YESBINGO": "game_name",
    "JDB": "game_name",
    "JILI2": "game_name",
    "EPIC2": "GameName",
    "HBNR": "Name",
    "CQ9": "gamename",
    "FC": "gameNameOfEnglish",
    "PP-S": "gameName",
    "MG": "game_name",
    "SPNX": "game_name",
    "SPDG": "game_name",
    "BG": "game_name",
    "HSG": "game_name",
    "RG": "game_name",
    "EVOP": "game_name",
    "PNG": "game_name",
    "EVONTT": "game_name",
    "EVORT": "game_name",
    "EVOBTG": "game_name",
    "EVONLC": "game_name",
    "BNG": "game_name",
    "AP": "game_name",
    "ALG": "game_name",
    "SPB": "game_name",
    //"CQ9": "game_name",
    "BG-S": "game_name",
    "PP-S123": "gameName",
    "HSD": "game_name",
    "YGR": "EnName",
    "MEGAH5": "GameName",
  },
  adminAccessOptions: [
    'account', 'ticket', 'bank', 'promotion', 'rescuefund', 'turnovertier', 'vip', 'setup', 'providerwinlose', 'affiliate', 'export_excel', 'cms'
  ],
  operatorAccessOptions: [
    'account', 'ticket', 'bank', 'promotion', 'rescuefund', 'turnovertier', 'vip', 'setup', 'providerwinlose', 'export_excel', 'cms'
  ],
  adminPages: [
    'operator', 'matchlist', 'teamlist'
  ],
  intMaxValue: 2000000000,
  enTitleSetting: {
    height: '80px',
    format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
  },
  filTitleSetting: {
    height: '80px',
    format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
  },
  enBodySetting: {
    format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
  },
  filBodySetting: {
    format_tags: 'p;h1;h2;h3;h4;h5;h6;pre;address;div'
  },
  useConfigUrl: process.env.VUE_APP_STATIC_URL == "true",
  getDomain(url, subdomain) {
    subdomain = subdomain || false;

    url = url.replace(/(https?:\/\/)?(www.)?/i, "");

    if (!subdomain) {
      url = url.split(".");

      url = url.slice(url.length - 2).join(".");
    }

    if (url.indexOf("/") !== -1) {
      return url.split("/")[0];
    }

    return url;
  },
  getBaseUrl() {
    if (this.useConfigUrl) {
      return this.baseUrl;
    }
    var domain = this.getDomain(window.location.hostname, false);
    if (domain != "localhost") {
      return "https://api." + domain;
    } else {
      return this.baseUrl;
    }
  },
  accountAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountadd";
  },
  accountDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountdetail";
  },
  accountEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountedit";
  },
  accountListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountlist";
  },
  accountLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountlogin";
  },
  accountProfileUnblockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountprofileunblock";
  },
  accountSocialGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsocialget";
  },
  accountSocialUpsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsocialupsert";
  },
  accountStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountstatusupdate";
  },
  accountSubAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubadd";
  },
  accountSubBlockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubblock";
  },
  accountSubDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubdetail";
  },
  accountSubEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubedit";
  },
  accountSubListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsublist";
  },
  accountSubUnblockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountsubunblock";
  },
  passwordResetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordreset";
  },
  passwordResetMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetmember";
  },
  passwordResetSubUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetsub";
  },
  passwordUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordupdate";
  },
  refereeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/refereelist";
  },
  securityUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/securityupdate";
  },
  securityValidateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/securityvalidate";
  },
  bankAccountGroupAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountgroupadd";
  },
  bankAccountGroupListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountgrouplist";
  },
  bankAccountGroupRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountgroupremove";
  },
  bankAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankadd";
  },
  bankEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankedit";
  },
  bankGroupAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankgroupadd";
  },
  bankGroupDefaultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankgroupdefault";
  },
  bankGroupEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankgroupedit";
  },
  bankGroupListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankgrouplist";
  },
  bankListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklist";
  },
  bankListWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistwithdrawal";
  },
  bankLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklookup";
  },
  bankMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberlist";
  },
  bankMemberStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberstatusupdate";
  },
  bankMemberUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberupdate";
  },
  bankResetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankreset";
  },
  bankSettingListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banksettinglist";
  },
  bankSettingUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banksettingupdate";
  },
  bankStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankstatusupdate";
  },
  iBankListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ibanklist";
  },
  ibankStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ibankstatusupdate";
  },
  campaignAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignadd";
  },
  campaignEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignedit";
  },
  campaignListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignlist";
  },
  campaignLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignlookup";
  },
  couponAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/couponadd";
  },
  couponGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/couponget";
  },
  couponListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/couponlist";
  },
  couponUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/couponupdate";
  },
  globalSettingListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettinglist";
  },
  globalSettingUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingupdate";
  },
  globalSettingList2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettinglist2";
  },
  globalSettingUpdate2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingupdate2";
  },
  providerMaintenanceListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenancelist";
  },
  providerMaintenanceUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenanceupdate";
  },
  memberEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberedit";
  },
  memberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlist";
  },
  memberProfileBankGroupUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilebankgroupupdate";
  },
  memberProfilePromotionGroupUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilepromotiongroupupdate";
  },
  memberProfileWithdrawalLimitUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilewithdrawallimitupdate";
  },
  memberStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberstatusupdate";
  },
  memberStatusUpdateReferralUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberstatusupdatereferral";
  },
  memberTacBankGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membertacbankget";
  },
  memberTacGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membertacget";
  },
  memberUnblockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberunblock";
  },
  memberWalletAdjustUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletadjust";
  },
  promotionAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionadd";
  },
  promotionClaimTypeLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionclaimtypelookup";
  },
  promotionGroupAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupadd";
  },
  promotionGroupDefaultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupdefault";
  },
  promotionGroupEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupedit";
  },
  promotionGroupListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongrouplist";
  },
  promotionGroupNormAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupnormadd";
  },
  promotionGroupNormListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupnormlist";
  },
  promotionGroupNormRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupnormremove";
  },
  promotionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionlist";
  },
  promotionMemberKnockOffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberknockoff";
  },
  promotionMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberlist";
  },
  promotionSignupEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupedit";
  },
  promotionSignupGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupget";
  },
  promotionSignupStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupstatusupdate";
  },
  promotionStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionstatusupdate";
  },
  ticketApproveDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketapprovedeposit";
  },
  ticketApproveWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketapprovewithdrawal";
  },
  ticketDepositApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdepositapprove";
  },
  ticketDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdetail";
  },
  ticketListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlist";
  },
  ticketListPendingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistpending";
  },
  ticketRedepositApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketredepositapprove";
  },
  ticketRejectDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectdeposit";
  },
  ticketRejectWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectwithdrawal";
  },
  withdrawalLimitAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawallimitadd";
  },
  withdrawalLimitDefaultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawallimitdefault";
  },
  withdrawalLimitEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawallimitedit";
  },
  withdrawalLimitListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawallimitlist";
  },
  vipLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/viplookup";
  },
  vipListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/viplist";
  },
  vipProviderEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipprovideredit";
  },
  vipProviderListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipproviderlist";
  },
  vipCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipcount";
  },
  vipAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipadd";
  },
  vipDefaultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipdefault";
  },
  vipDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipdetail";
  },
  vipEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipedit";
  },
  vipMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipmove";
  },
  vipProviderEditBatchUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/vipprovidereditbatch";
  },
  rescueFundListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundlist";
  },
  rescueFundAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundadd";
  },
  rescueFundStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundstatusupdate";
  },
  rescueFundCustomMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundcustommemberlist";
  },
  rescueFundCustomMemberAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundcustommemberadd";
  },
  rescueFundCustomMemberDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundcustommemberdelete";
  },
  turnoverTierListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertierlist";
  },
  turnoverTierCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertiercount";
  },
  turnoverTierAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertieradd";
  },
  turnoverTierDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertierdetail";
  },
  turnoverTierDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertierdelete";
  },
  turnoverTierEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/turnovertieredit";
  },
  betListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlist";
  },
  logMatchResultUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/logmatchresult";
  },
  logMatchTeamUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/logmatchteam";
  },
  matchListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/matchlist";
  },
  resultInsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/resultinsert";
  },
  resultListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/resultlist";
  },
  resultUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/resultupdate";
  },
  teamListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/teamlist";
  },
  teamLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/teamlookup";
  },
  teamUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/teamupdate";
  },
  bankStatementUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankstatement";
  },
  bankStatementDailyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankstatementdaily";
  },
  currentMonthNonDepositorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/currentmonthnondepositor";
  },
  currentMonthNoLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/currentmonthnologin";
  },
  oneTimeDepositorUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/onetimedepositor";
  },
  bankAdjustUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankadjust";
  },
  bankTransferUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banktransfer";
  },
  dailyStatementUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailystatement";
  },
  platformWinLoseUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/platformwinlose";
  },
  gameResultSlotsUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultslots";
  },
  gameResultLivecasinoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultlivecasino";
  },
  gameResultLivecasinoDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultlivecasinodetail";
  },
  gameResultRebateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultrebate";
  },
  gameResultSportsbookUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultsportsbook";
  },
  gameResultCockfightUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultcockfight";
  },
  gameResultRescueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultrescue";
  },
  promotionSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsummary";
  },
  promotionSummaryDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsummarydetail";
  },
  bonusIssueUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonusissue";
  },
  bonusIssuePromoUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonusissuepromo";
  },
  promotionMemberAssignUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionmemberassign";
  },
  memberVipGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membervipget";
  },
  memberVipUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membervipupdate";
  },
  memberDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberdetail";
  },
  memberProfileGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofileget";
  },
  memberProfilePromotionGroupUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilepromotiongroupupdate";
  },
  memberProfileWithdrawalLimitUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilewithdrawallimitupdate";
  },
  memberProfileBankGroupUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberprofilebankgroupupdate";
  },
  betLimitProviderListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitproviderlist";
  },
  betLimitProviderUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitproviderupdate";
  },
  betLimitMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitmemberlist";
  },
  betLimitMemberUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/betlimitmemberupdate";
  },
  bankListDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistdeposit";
  },
  promotionLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionlookup";
  },
  adjustmentListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adjustmentlist";
  },
  bonusListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonuslist";
  },
  dailySummaryCompanyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailysummarycompany";
  },
  dailySummaryMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailysummarymember";
  },
  promotionSignupUnusedListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupunusedlist";
  },
  promotionSignupOngoingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupongoing";
  },
  inboxListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/inboxlist";
  },
  gameResultChangesUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gameresultchanges";
  },
  dashboardUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dashboard";
  },
  ticketListPendingCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistpendingcount";
  },
  memberSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membersummary";
  },
  providerGameOffAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providergameoffadd";
  },
  providerGameOffListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providergameofflist";
  },
  providerGameOffRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providergameoffremove";
  },
  providerRtpListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerrtplist";
  },
  providerRtpEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerrtpedit";
  },
  depositedMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/depositedmember";
  },
  registeredMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/registeredmember";
  },
  rebateGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebateget";
  },
  checkMemberFreeSpinUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/checkmemberfreespin";
  },
  firstDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/firstdeposit";
  },
  promotionSignupAssignUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionsignupassign";
  },
  providerWinLoseCompanyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerwinlosecompany";
  },
  // accountDetailAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountdetailaffiliate";
  // },
  // accountListAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountlistaffiliate";
  // },
  // accountStatusUpdateAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountstatusupdateaffiliate";
  // },
  // accountUnblockAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountunblockaffiliate";
  // },
  // accountUpdateAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountupdateaffiliate";
  // },
  // affiliateApproveUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/affiliateapprove";
  // },
  // passwordResetAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/passwordresetaffiliate";
  // },
  // bankAccountListAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/bankaccountlistaffiliate";
  // },
  // bankAccountUpdateAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/bankaccountupdateaffiliate";
  // },
  // ticketApproveaffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/ticketapproveaffiliate";
  // },
  // ticketListAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/ticketlistaffiliate";
  // },
  // ticketRejectAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectaffiliate";
  // },
  // walletAdjustAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/walletadjustaffiliate";
  // },
  commPackageLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/commpackagelookup";
  },
  // accountCommUpdateAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountcommupdateaffiliate";
  // },
  bankAccountWithdrawalListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountwithdrawallist";
  },
  // accountSubDetailAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountsubdetailaffiliate";
  // },
  // settlementListAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/settlementlistaffiliate";
  // },
  // commUpdateLogAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/commupdatelogaffiliate";
  // },
  // dailyWinLoseAffUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/dailywinloseaff";
  // },
  // dailyWinLoseAffiliateAffUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/dailywinloseaffiliateaff";
  // },
  // dailyWinLoseAffiliateMemberAffUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/dailywinloseaffiliatememberaff";
  // },
  // dailyWinLoseMemberAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosememberaffiliate";
  // },
  tacGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/tacget";
  },
  // accountMemberListAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountmemberlistaffiliate";
  // },
  // accountMemberListMasterAffiliateUrl() {
  //   return this.getBaseUrl() + this.userBaseUrl + "/accountmemberlistmasteraffiliate";
  // },
  memberVipLogUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberviplog";
  },
  auditLoginMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditloginmember";
  },
  auditFreebiesListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditfreebieslist";
  },
  auditFreebiesAckUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditfreebiesack";
  },
  reviewListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/reviewlist";
  },
  reviewDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/reviewdetail";
  },
  reviewReplyUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/reviewreply";
  },
  monthlyRatingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/monthlyrating";
  },
  recentDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/recentdeposit";
  },
  monthlyRatingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/monthlyrating";
  },
  surveyAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveyadd";
  },
  surveyLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveylookup";
  },
  surveyStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveystatusupdate";
  },
  surveyStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/surveystatusupdate";
  },
  memberBonusPromotionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberbonuspromotionlist";
  },
  memberBonusPromotionAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberbonuspromotionadd";
  },
  memberBonusPromotionDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberbonuspromotiondelete";
  },
  globalSettingDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingdetail";
  },

  cmsAnnouncementBannerAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbanneradd";
  },
  cmsAnnouncementBannerCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannercount";
  },
  cmsAnnouncementBannerDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerdelete";
  },
  cmsAnnouncementBannerDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerdetail";
  },
  cmsAnnouncementBannerEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbanneredit";
  },
  cmsAnnouncementBannerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerlist";
  },
  cmsAnnouncementBannerMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannermove";
  },
  cmsAnnouncementBannerStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerstatusupdate";
  },
  cmsAnnouncementBannerUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsannouncementbannerupdown";
  },

  cmsPromotionBannerAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbanneradd";
  },
  cmsPromotionBannerCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannercount";
  },
  cmsPromotionBannerDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerdelete";
  },
  cmsPromotionBannerDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerdetail";
  },
  cmsPromotionBannerEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbanneredit";
  },
  cmsPromotionBannerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerlist";
  },
  cmsPromotionBannerMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannermove";
  },
  cmsPromotionBannerStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerstatusupdate";
  },
  cmsPromotionBannerUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmspromotionbannerupdown";
  },

  cmsSEOPageAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopageadd";
  },
  cmsSEOPageDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagedelete";
  },
  cmsSEOPageDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagedetail";
  },
  cmsSEOPageEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopageedit";
  },
  cmsSEOPageListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagelist";
  },
  cmsSEOPageStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsseopagestatusupdate";
  },

  cmsSlideBannerAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebanneradd";
  },
  cmsSlideBannerCountUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannercount";
  },
  cmsSlideBannerDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerdelete";
  },
  cmsSlideBannerDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerdetail";
  },
  cmsSlideBannerEditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebanneredit";
  },
  cmsSlideBannerListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerlist";
  },
  cmsSlideBannerMoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannermove";
  },
  cmsSlideBannerStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerstatusupdate";
  },
  cmsSlideBannerUpDownUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cmsslidebannerupdown";
  },

  providerMaintenanceClearUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providermaintenanceclear";
  },
  dailyWinLoseUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlose";
  },
  clearOutstandingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/clearoutstanding";
  },
  memberWalletGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberwalletget";
  },
  traceOutstandingUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/traceoutstanding";
  },
  promotionCategoryLookupUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotioncategorylookup";
  },
  crmListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/crmlist";
  },
  ipWhitelistListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipwhitelistlist";
  },
  ipWhitelistAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipwhitelistadd";
  },
  ipWhitelistDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipwhitelistdelete";
  },
  paymentOptionListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionlist";
  },
  paymentOptionProviderListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionproviderlist";
  },
  paymentOptionProviderUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionproviderupdate";
  },
  paymentOptionUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionupdate";
  },
  memberListForBonusPromotionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlistforbonuspromotion";
  },
  bonusIssuePromoBulkUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonusissuepromobulk";
  },
  bonusIssueBulkUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonusissuebulk";
  },
  bankMemberEWalletListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberewalletlist";
  },
  bankMemberEWalletStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberewalletstatusupdate";
  },
  bankMemberEWalletUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankmemberewalletupdate";
  },
  ticketListAutoWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistautowithdrawal";
  },
  ticketLogAutoWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlogautowithdrawal";
  },
  bankListAutoWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/banklistautowithdrawal";
  },
  withdrawalAIPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalaipay";
  },
  withdrawalRMPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalrmpay";
  },
  withdrawalHTPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalhtpay";
  },
  withdrawalMAYAPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmayapay";
  },
  pgProviderGetBalanceUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/pgprovidergetbalance";
  },
  ticketRejectApprovedWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketrejectapprovedwithdrawal";
  },
  withdrawalGOPayGcashUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalgopaygcash";
  },
  withdrawalGOPayMayaUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalgopaymaya";
  },
  withdrawalDGPayMayaUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldgpaymaya";
  },
  withdrawalDGPayGcashUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldgpaygcash";
  },
  withdrawalCloudPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalcloudpay";
  },
  withdrawalTopPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltoppay";
  },
  withdrawalANFUUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalanfu";
  },
  withdrawalShunfaPayGcashUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalshunfapaygcash";
  },
  withdrawalShunfaPayMayaUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalshunfapaymaya";
  },
  withdrawalWorldPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalworldpay";
  },
  withdrawalRGPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalrgpay";
  },
  withdrawalWCPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalwcpay";
  },
  withdrawalGOLDPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalgoldpay";
  },
  withdrawalXFTGcashUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalxftgcash";
  },
  withdrawalMasayaPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmasayapay";
  },
  withdrawalTYGPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltygpay";
  },
  withdrawalXYPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalxypay";
  },
  withdrawalCTPayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalctpay";
  },

  auditTicketWalletTransUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditticketwallettrans";
  },
  utmListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/utmlist";
  },
  paymentOptionProviderUpdateRecommendUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionproviderupdaterecommend";
  },
  paymentOptionProviderUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionproviderupdateseq";
  },
  memberSummaryV2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/membersummaryv2";
  },
  ipAssociateListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ipassociatelist";
  },
  auditLoginMemberV2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/auditloginmemberv2";
  },
  paymentOptionProviderUpdateLimitUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionproviderupdatelimit";
  },
  rebateSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebatesummary";
  },
  rebateSummaryv2Url() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebatesummaryv2";
  },
  rebateProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebateprovider";
  },
  rebateListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebatelist";
  },
  rebateListMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rebatelistmember";
  },
  ticketListReviewAuditUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistreviewaudit";
  },
  ticketReviewAuditWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketreviewauditwithdrawal";
  },
  systemBalanceUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/systembalance";
  },
  promotionGroupNormUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotiongroupnormupdateseq";
  },
  promotionUpdateProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionupdateprovider";
  },
  promotionUpdatePaymentOptionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionupdatepaymentoption";
  },
  promotionUpdatePaymentGatewayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionupdatepaymentgateway";
  },
  promotionLookupDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionlookupdeposit";
  },
  promotionCustomMemberListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotioncustommemberlist";
  },
  promotionCustomMemberAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotioncustommemberadd";
  },
  promotionCustomMemberDeleteUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotioncustommemberdelete";
  },
  dailyWinLoseSBUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosesb";
  },
  dailyWinLoseSBDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosesbdetail";
  },
  campaignUpdateProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/campaignupdateprovider";
  },
  bankProviderListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankproviderlist";
  },
  bankProviderUpdateVipUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankproviderupdatevip";
  },
  memberCustomVipListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membercustomviplist";
  },
  memberCustomVipUnlockUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/membercustomvipunlock";
  },
  bonusSmarticoSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonussmarticosummary";
  },
  bonusSmarticoDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonussmarticodetail";
  },
  bonusSmarticoSummaryExpiredUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonussmarticosummaryexpired";
  },
  bonusSmarticoDetailExpiredUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bonussmarticodetailexpired";
  },
  epic2GetUnfinishRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epic2getunfinishround";
  },
  epic2CancelUnfinishRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epic2cancelunfinishround";
  },
  epic2CreateFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epic2createfreeround";
  },
  epic2GetFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epic2getfreeround";
  },
  epic2GetFreeRoundGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/epic2getfreeroundgamelist";
  },
  megah5GetUnfinishRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5getunfinishround";
  },
  megah5CancelUnfinishRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5cancelunfinishround";
  },
  megah5CreateFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5createfreeround";
  },
  megah5GetFreeRoundUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5getfreeround";
  },
  megah5GetFreeRoundGameListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/megah5getfreeroundgamelist";
  },
  recentInboxClaimUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/recentinboxclaim";
  },
  ticketDepositGatewayApproveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdepositgatewayapprove";
  },
  providerWinLoseMemberUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/providerwinlosemember";
  },
  retentionUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/retention";
  },
  cohortDayUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortday";
  },
  cohortMonthUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortmonth";
  },
  cohortYearUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortyear";
  },
  promotionWithdrawalSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/promotionwithdrawalsummary";
  },
  cohortDayDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortdaydetail";
  },
  cohortMonthDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortmonthdetail";
  },
  cohortYearDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/cohortyeardetail";
  },
  uniqueLoginUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/uniquelogin";
  },
  uniqueWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/uniquewithdrawal";
  },
  secondDepositUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/seconddeposit";
  },
  ticketWithdrawalRollbackDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketwithdrawalrollbackdetail";
  },
  ticketWithdrawalRejectDetailUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketwithdrawalrejectdetail";
  },
  ticketAuditWithdrawalUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketauditwithdrawal";
  },
  paymentOptionUpdateSeqUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/paymentoptionupdateseq";
  },
  labelAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/labeladd";
  },
  labelListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/labellist";
  },
  labelStatusUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/labelstatusupdate";
  },
  memberLabelGetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlabelget";
  },
  memberLabelGetAvailableUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlabelgetavailable";
  },
  memberLabelUpsertUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlabelupsert";
  },
  memberLabelListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlabellist";
  },
  bankDefaultSenderListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankdefaultsenderlist";
  },
  bankDefaultSenderRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankdefaultsenderremove";
  },
  bankDefaultSenderSetUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankdefaultsenderset";
  },
  exchangeRateListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/exchangeratelist";
  },
  exchangeRateUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/exchangerateupdate";
  },
  ticketProcessWithdrawalRollbackUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketprocesswithdrawalrollback";
  },
  iframeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/iframelist";
  },
  iframeUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/iframeedit";
  },
  iframeRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/iframeremove";
  },
  exchangeRateListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/exchangeratelist";
  },
  exchangeRateUpdateUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/exchangerateupdate";
  },
  rescueFundPayoutSummaryUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundpayoutsummary";
  },
  rescueFundPayoutListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundpayoutlist";
  },
  rescueFundPayoutProviderUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/rescuefundpayoutprovider";
  },
  dailyWinLoseGameUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosegame";
  },
  gameNameExcludeListUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamenameexcludelist";
  },
  gameNameExcludeAddUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamenameexcludeadd";
  },
  gameNameExcludeRemoveUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/gamenameexcluderemove";
  },

  accountApproveAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountapproveaff";
  },
  accountDetailAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountdetailaff";
  },
  accountEditAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accounteditaff";
  },
  accountListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountlistaff";
  },
  accountMoveAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountmoveaff";
  },
  accountStatusUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountstatusupdateaff";
  },
  carryOverUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/carryoverupdateaff";
  },
  commissionGetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/commissiongetaff";
  },
  commissionUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/commissionupdateaff";
  },
  globalSettingDetailAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingdetailaff";
  },
  globalSettingListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettinglistaff";
  },
  globalSettingUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/globalsettingupdateaff";
  },
  settlementTypeUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlementtypeupdateaff";
  },
  walletAdjustAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/walletadjustaff";
  },
  carryOverGetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/carryovergetaff";
  },
  settlementTypeGetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlementtypegetaff";
  },
  accountProfileUnblockAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/accountprofileunblockaff";
  },
  passwordResetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/passwordresetaff";
  },
  bankAccountListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountlistaff";
  },
  bankAccountUpdateAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/bankaccountupdateaff";
  },
  ticketListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistaff";
  },
  ticketListPendingAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistpendingaff";
  },
  ticketReviewAuditWithdrawalAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketreviewauditwithdrawalaff";
  },
  ticketListReviewAuditAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketlistreviewauditaff";
  },
  dailyWithdrawalAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywithdrawalaff";
  },
  dailyWithdrawalAgentAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywithdrawalagentaff";
  },
  adjustmentListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/adjustmentlistaff";
  },
  settlementListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/settlementlistaff";
  },
  dailyStatementAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailystatementaff";
  },
  memberListAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/memberlistaff";
  },
  ticketDetailAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/ticketdetailaff";
  },
  dailyWinLoseAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinloseaff";
  },
  dailyWinLoseCategoryAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosecategoryaff";
  },
  dailyWinLoseMemberAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosememberaff";
  },
  dailyWinLoseMemberCategoryAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailywinlosemembercategoryaff";
  },
  dailyDepositAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailydepositaff";
  },
  dailyDepositMemberAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dailydepositmemberaff";
  },
  dashboardAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/dashboardaff";
  },
  tacGetAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/tacgetaff";
  },

  withdrawalAIPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalaipayaff";
  },
  withdrawalRMPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalrmpayaff";
  },
  withdrawalHTPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalhtpayaff";
  },
  withdrawalMAYAPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmayapayaff";
  },
  withdrawalGOPayGcashAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalgopaygcashaff";
  },
  withdrawalGOPayMayaAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalgopaymayaaff";
  },
  withdrawalDGPayMayaAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldgpaymayaaff";
  },
  withdrawalDGPayGcashAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaldgpaygcashaff";
  },
  withdrawalCloudPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalcloudpayaff";
  },
  withdrawalTopPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltoppayaff";
  },
  withdrawalANFUAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalanfuaff";
  },
  withdrawalShunfaPayGcashAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalshunfapaygcashaff";
  },
  withdrawalShunfaPayMayaAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalshunfapaymayaaff";
  },
  withdrawalWorldPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalworldpayaff";
  },
  withdrawalRGPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalrgpayaff";
  },
  withdrawalWCPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalwcpayaff";
  },
  withdrawalGOLDPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalgoldpayaff";
  },
  withdrawalXFTGcashAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalxftgcashaff";
  },
  withdrawalMasayaPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalmasayapayaff";
  },
  withdrawalTYGPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawaltygpayaff";
  },
  withdrawalXYPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalxypayaff";
  },
  withdrawalCTPayAffUrl() {
    return this.getBaseUrl() + this.userBaseUrl + "/withdrawalctpayaff";
  },
};
